import { Card, styled } from '@mui/material';

export const StyledAccountCardSkeleton = styled(Card)(({ theme }) => ({
	height: '100%',
	borderRadius: 6,
	padding: theme.spacing(3),
	background: theme.palette.background.paper,
}));
